export default __webpack_public_path__ + "static/media/blackboard-hover.7a010a08.svg";